import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearHighlights,
  highlightTextMatches,
  scrollToMatch,
  scrollToTop,
} from "./findInPage";
import {
  resetCounter,
  setTotalMatch,
} from "../../features/findInPage/FindInPageSlice";

export function useFindInPageHighlighter(rootRef) {
  const searchTerm = useSelector((state) => state.findInPage.searchTerm);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!rootRef?.current) return;

    const root = rootRef.current;
    clearHighlights(root);
    dispatch(resetCounter());

    if (searchTerm) {
      const totalMatch = highlightTextMatches(root, searchTerm);
      dispatch(setTotalMatch(totalMatch));
      if (totalMatch > 0) {
        scrollToMatch(0);
      } else {
        scrollToTop(root);
      }
    }
  }, [searchTerm, rootRef]);
}
